module.exports = __webpack_public_path__ + "img/Download All WhatsApp Mods.087f8a0d.webp";